import React, { useState } from 'react';
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import BuildIcon from '@material-ui/icons/Build';
import SearchIcon from '@material-ui/icons/Search';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import Draggable from 'react-draggable';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { InvestigateBackdrop, ParseDocumentBackdrop } from '../Backdrop';
import SpecDocument from '../../libs/SpecDocument';
import { DocumentTablesTypes } from '../../libs/specParser';

interface AdminToolsSpeedDialProps extends RouteComponentProps {}

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: 'fixed',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  input: {
    display: 'none',
  },
}));

export const AdminToolsSpeedDial = withRouter((props: AdminToolsSpeedDialProps) => {
  const classes = useStyles();
  const [toolsVisibility, setToolsVisibility] = useState(false as boolean);
  const [investigateVisibility, setInvestigateVisibility] = useState(
    false as boolean
  );
  const [parseDocumentVisibility, setParseDocumentVisibility] = useState(
    false as boolean
  );
  const [parsedSpecDocument, setParsedSpecDocument] = useState(
    null as DocumentTablesTypes | null
  );
  const [isParsingSpecDocument, setIsParsingSpecDocument] = useState(
    false as boolean
  );

  const handeHideTools = () => setToolsVisibility(false);

  const handleToggleTools = () => setToolsVisibility(!toolsVisibility);

  const handleShowInvestigate = () => setInvestigateVisibility(true);

  const handleHideInvestigate = () => setInvestigateVisibility(false);

  const handleShowParseDocument = () => setParseDocumentVisibility(true);

  const handleHideParseDocument = () => setParseDocumentVisibility(false);

  const actions = [
    {
      icon: <InsertDriveFileIcon />,
      name: 'Parse Document',
      clickHandler: () => {
        props.history.push('/admin/document-parser');
      },
    },
    {
      icon: <SearchIcon />,
      name: 'Investigate Submission',
      clickHandler: () => handleShowInvestigate(),
    },
  ];

  return (
    <>
      <input
        accept="application/msword"
        className={classes.input}
        id="spec-button-file"
        type="file"
        onClick={(e: any) => {
          e.target.value = '';
        }}
        onChange={async (event: any) => {
          if (!!event.target.files[0]) {
            setIsParsingSpecDocument(true);
            handleShowParseDocument();
            const result = await SpecDocument.getTables(event.target.files[0]);
            setParsedSpecDocument(result);
            setIsParsingSpecDocument(false);
          }
        }}
      />
      <Draggable>
        <SpeedDial
          ariaLabel="SpeedDial example"
          className={classes.speedDial}
          icon={<SpeedDialIcon icon={<BuildIcon />} />}
          onClose={handeHideTools}
          onClick={handleToggleTools}
          open={toolsVisibility}
          direction="up"
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={() => {
                handeHideTools();
                action.clickHandler();
              }}
            />
          ))}
        </SpeedDial>
      </Draggable>
      <InvestigateBackdrop
        visibility={investigateVisibility}
        onClose={handleHideInvestigate}
      />
      <ParseDocumentBackdrop
        isLoading={isParsingSpecDocument}
        spec={parsedSpecDocument}
        visibility={parseDocumentVisibility}
        onClose={handleHideParseDocument}
      />
    </>
  );
});
